import Gallery from "../components/about/Campus/Gallery/gallery";

export const GalleryView = () => (
    <Gallery />
)